var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showModal
    ? _c(
        "portal",
        { attrs: { to: "modal" } },
        [
          _c("transition", { attrs: { name: "modal-fade" } }, [
            _vm.showModal
              ? _c(
                  "div",
                  _vm._g(
                    {
                      staticClass:
                        "modal flex flex-col fixed inset-0 items-center sm:justify-center",
                      class: _vm.backdropClasses,
                    },
                    _vm.closeOutOfFocus ? { click: _vm.onClose } : {}
                  ),
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-col modal bg-white rounded opacity-100 justify-between border-t-6 border-solid border-blue-500 min-w-160",
                        class: _vm.triggerClassModal,
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        _vm.showHeader
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "flex justify-between items-start py-4 px-8",
                                class: _vm.triggerClassHeader,
                              },
                              [
                                _vm._t("header", function () {
                                  return [_vm._v(" ")]
                                }),
                                _vm.closeButton
                                  ? _c(
                                      "div",
                                      { staticClass: "-me-4" },
                                      [
                                        _c(
                                          "base-button",
                                          {
                                            staticClass: "btn-icon ms-auto",
                                            on: { click: _vm.onClose },
                                          },
                                          [
                                            _c("svg-icon", {
                                              staticClass:
                                                "icon-md text-blue-800",
                                              attrs: { name: "close" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "scrollbar modal-content flex-grow",
                            class: _vm.triggerClassContent,
                          },
                          [_vm._t("default")],
                          2
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "modal-footer",
                            class: _vm.triggerClassFooter,
                          },
                          [_vm._t("footer")],
                          2
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }